/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// @ts-ignore
import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrderDeliveryAddress
 */
export interface OrderDeliveryAddress {
    /**
     * 
     * @type {string}
     * @memberof OrderDeliveryAddress
     */
    building: string;
    /**
     * 
     * @type {string}
     * @memberof OrderDeliveryAddress
     */
    street1: string;
    /**
     * 
     * @type {string}
     * @memberof OrderDeliveryAddress
     */
    street2: string;
    /**
     * 
     * @type {string}
     * @memberof OrderDeliveryAddress
     */
    postalCode: string;
    /**
     * 
     * @type {string}
     * @memberof OrderDeliveryAddress
     */
    region: string;
    /**
     * 
     * @type {string}
     * @memberof OrderDeliveryAddress
     */
    city: string;
    /**
     * 
     * @type {string}
     * @memberof OrderDeliveryAddress
     */
    countryCode: string;
    /**
     * 
     * @type {string}
     * @memberof OrderDeliveryAddress
     */
    additionalDescription: string;
}

/**
 * Check if a given object implements the OrderDeliveryAddress interface.
 */
// @ts-ignore
export function instanceOfOrderDeliveryAddress(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "building" in value;
    isInstance = isInstance && "street1" in value;
    isInstance = isInstance && "street2" in value;
    isInstance = isInstance && "postalCode" in value;
    isInstance = isInstance && "region" in value;
    isInstance = isInstance && "city" in value;
    isInstance = isInstance && "countryCode" in value;
    isInstance = isInstance && "additionalDescription" in value;

    return isInstance;
}

// @ts-ignore
export function OrderDeliveryAddressFromJSON(json: any): OrderDeliveryAddress {
    return OrderDeliveryAddressFromJSONTyped(json, false);
}

// @ts-ignore
export function OrderDeliveryAddressFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderDeliveryAddress {
// @ts-ignore
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'building': json['building'],
        'street1': json['street1'],
        'street2': json['street2'],
        'postalCode': json['postal_code'],
        'region': json['region'],
        'city': json['city'],
        'countryCode': json['country_code'],
        'additionalDescription': json['additional_description'],
    };
}

// @ts-ignore
export function OrderDeliveryAddressToJSON(value?: OrderDeliveryAddress | null): any {
// @ts-ignore
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'building': value.building,
        'street1': value.street1,
        'street2': value.street2,
        'postal_code': value.postalCode,
        'region': value.region,
        'city': value.city,
        'country_code': value.countryCode,
        'additional_description': value.additionalDescription,
    };
}

